import { InjectableApi } from '@shared/decorators'
import { ApiService } from '@shared/services'

@InjectableApi({
  providedIn: 'root',
  baseSegment: 'auth',
  // version: 'v2',
})
export class ThemeService extends ApiService {
  themeColor!: IColor
  //  mock object
  eleProperties = {
    buttonBg: '#8c38c4',
    buttonTextColor: '#8378de',
    buttonHoverBg: '#d8297d',
    tabActiveBg: '#f6bd30',
    menuBg: '#657c8a',
    menuHoverBg: '#2cacd5',
    topBannerBg: '#41a694',
    tabOutline: '#d82a13',
  }

  /**
   * @function getElementProp To get mock element props.
   * @returns Observable with the element style props.
   */
  getElementProp(): void {
    //  change API endpoints
    // this.post(`${this.baseSegment}/apiEndpoint`, {}).subscribe(
    //   (res) => {
    //   set the props
    //   },
    // )
    this.themeColor = this.eleProperties
    // uncomment below code
    // Object.keys(this.themeColor).forEach((key) => {
    //   document.documentElement.style.setProperty(`--${key}`, this.themeColor[key as keyof IColor])
    // })
  }
}

interface IColor {
  buttonBg: string
  buttonTextColor: string
  buttonHoverBg: string
  tabActiveBg: string
  menuBg: string
  menuHoverBg: string
  topBannerBg: string
  tabOutline: string
}
